module.exports = __webpack_public_path__ + "img/tw-card.c1114d68.jpg";